import { ClientProfileContentItem } from 'store/clientProfile/clientProfileSlice';

import { NoteForm } from '../NoteForm';
import { useNoteFormContext } from '../context';
import { AutosaveProvider } from '../context/autosaveContext';
import { useNoteFormActions } from '../hooks';

type DraftNoteFormProps = {
  clientId: string;
  note?: ClientProfileContentItem;
  expanded?: boolean;
};

const DraftNoteFormContent = ({ expanded }: { expanded: boolean }) => {
  const { isManagerReview, disabled } = useNoteFormContext();
  const { handleSubmit } = useNoteFormActions();

  return (
    <NoteForm.Form onSubmit={handleSubmit}>
      <NoteForm.FieldsContainer expanded={expanded}>
        <NoteForm.FieldsContainer.Row>
          <NoteForm.FieldsContainer.HalfRow>
            <NoteForm.Fields.NoteType disabled={disabled} />
          </NoteForm.FieldsContainer.HalfRow>
          <NoteForm.FieldsContainer.HalfRow>
            <NoteForm.Fields.DateOfEncounter disabled={disabled} />
          </NoteForm.FieldsContainer.HalfRow>
        </NoteForm.FieldsContainer.Row>

        {!isManagerReview && (
          <NoteForm.FieldsContainer.Row>
            <NoteForm.FieldsContainer.HalfRow>
              <NoteForm.Fields.StartTime disabled={disabled} />
            </NoteForm.FieldsContainer.HalfRow>
            <NoteForm.FieldsContainer.HalfRow>
              <NoteForm.Fields.TimeSpent disabled={disabled} />
            </NoteForm.FieldsContainer.HalfRow>
          </NoteForm.FieldsContainer.Row>
        )}

        {isManagerReview && (
          <>
            <NoteForm.FieldsContainer.Row>
              <NoteForm.FieldsContainer.HalfRow>
                <NoteForm.Fields.TimeSpent disabled={disabled} />
              </NoteForm.FieldsContainer.HalfRow>
              <NoteForm.FieldsContainer.HalfRow>
                <NoteForm.Fields.Manager disabled={disabled} />
              </NoteForm.FieldsContainer.HalfRow>
            </NoteForm.FieldsContainer.Row>
            <NoteForm.FieldsContainer.Row>
              <NoteForm.FieldsContainer.HalfRow>
                <NoteForm.Fields.Chw disabled={disabled} />
              </NoteForm.FieldsContainer.HalfRow>
              <NoteForm.FieldsContainer.HalfRow>
                <NoteForm.Fields.Provider disabled={disabled} />
              </NoteForm.FieldsContainer.HalfRow>
            </NoteForm.FieldsContainer.Row>
          </>
        )}

        {!isManagerReview && (
          <>
            <NoteForm.FieldsContainer.Row>
              <NoteForm.FieldsContainer.HalfRow>
                <NoteForm.Fields.NextContact disabled={disabled} />
              </NoteForm.FieldsContainer.HalfRow>
            </NoteForm.FieldsContainer.Row>
            <NoteForm.FieldsContainer.Row>
              <NoteForm.FieldsContainer.HalfRow>
                <NoteForm.Fields.WhoDidYouReach disabled={disabled} />
              </NoteForm.FieldsContainer.HalfRow>
            </NoteForm.FieldsContainer.Row>
            <NoteForm.FieldsContainer.FullWidth>
              <NoteForm.Fields.TypeOfSupport disabled={disabled} />
            </NoteForm.FieldsContainer.FullWidth>
          </>
        )}
      </NoteForm.FieldsContainer>

      <NoteForm.FieldsContainer.HalfRow>
        <NoteForm.Fields.Note disabled={disabled} />
      </NoteForm.FieldsContainer.HalfRow>
      <NoteForm.FieldsContainer.HalfRow>
        <NoteForm.Fields.DocumentationTime disabled={disabled} />
      </NoteForm.FieldsContainer.HalfRow>

      <NoteForm.Actions>
        <NoteForm.Actions.Left>
          <NoteForm.DeleteButton />
        </NoteForm.Actions.Left>
        <NoteForm.Actions.Right>
          <NoteForm.AutosaveIndicator />
          <NoteForm.SubmitButton>Final</NoteForm.SubmitButton>
        </NoteForm.Actions.Right>
      </NoteForm.Actions>
    </NoteForm.Form>
  );
};

/**
 * Preset component for editing draft notes with autosave.
 * This is the pattern used in the notes section (noteSection context).
 */
export const DraftNoteForm = ({ clientId, note, expanded = true }: DraftNoteFormProps) => {
  return (
    <NoteForm.Root clientId={clientId} note={note} disabled={false}>
      <AutosaveProvider>
        <DraftNoteFormContent expanded={expanded} />
      </AutosaveProvider>
    </NoteForm.Root>
  );
};
